export default "__VITE_ASSET__CL2RvAyJ__"